import { lastValueFrom } from 'rxjs';

import {
  desktopMenuOpened, EmptyItemEspotType, hideAppFooter, hideFullScreen, hideFullScreenContainerMobile,
  hideOverlay, searchDropdownOpened, setEmptyItemEspots, setFullScreenContainerMobileAnimation,
  setLayoutEspots,
  setSelectedFilterMobile,
  showAppFooter, showFullScreen, showFullScreenContainerMobile, showOverlay
} from '@/redux/slices/gui.slice';
import { connectUserSuccess } from '@/redux/slices/auth.slice';
import { AppListenerEntry } from '@/redux';
import { valueof } from '@/types';
import { ANIMATION } from '@/constants/animation';
import { FULL_SCREEN_CONTAINER_MOBILE } from '@/constants/gui';
import { ESPOTS } from '@/constants/espot';

export const epicSearchDropdownOpened: AppListenerEntry = {
  actionCreator: searchDropdownOpened,
  effect: ({ payload }: ReturnType<typeof searchDropdownOpened>, { dispatch }) => {
    if (payload.isMobile) {
      dispatch(payload.opened ? hideAppFooter() : showAppFooter());
    }
  }
};

export const epicDesktopMenuOpened: AppListenerEntry = {
  actionCreator: desktopMenuOpened,
  effect: ({ payload }: ReturnType<typeof desktopMenuOpened>, { dispatch }) => {
    dispatch(payload.opened ? showOverlay() : hideOverlay());
  }
};

export const epicShowFullScreen: AppListenerEntry = {
  actionCreator: showFullScreen,
  effect: async ({ payload }: ReturnType<typeof showFullScreen>, { dispatch, delay }) => {
    const { fullScreenType, onShow, selectedFilter } = payload;
    const animation = payload.isMobile ? ANIMATION.FROM_DOWN : ANIMATION.FROM_LEFT;

    if (fullScreenType === FULL_SCREEN_CONTAINER_MOBILE.FILTER && selectedFilter) {
      dispatch(setSelectedFilterMobile({ selectedFilter }));
    }

    dispatch(showFullScreenContainerMobile({ modalType: fullScreenType }));
    dispatch(setFullScreenContainerMobileAnimation({ animation }));
    await delay(ANIMATION.DELAY);
    dispatch(setFullScreenContainerMobileAnimation({ animation: ANIMATION.CLEAR }));
  }
};

export const epicHideFullScreen: AppListenerEntry = {
  actionCreator: hideFullScreen,
  effect: async ({ payload }: ReturnType<typeof hideFullScreen>, { dispatch, delay }) => {
    const { fullScreenType, onHide } = payload;
    if (onHide) {
      onHide();
    }
    const animation = payload.isMobile ? ANIMATION.TO_DOWN : ANIMATION.TO_LEFT;

    dispatch(setFullScreenContainerMobileAnimation({ animation }));
    dispatch(hideFullScreenContainerMobile({ modalType: fullScreenType }));
    await delay(ANIMATION.DELAY);
    dispatch(setFullScreenContainerMobileAnimation({ animation: ANIMATION.CLEAR }));
  }
};

export const getEspotWhenUserConnect: AppListenerEntry = {
  actionCreator: connectUserSuccess,
  effect: async (_, { dispatch, extra: { espotService }, getState }) => {
    const espots: valueof<typeof ESPOTS>[] = [ESPOTS.HEADER_PROMOTION, ESPOTS.CART_SECURE_INFO, ESPOTS.FOOTER_LEGAL_NOTICE];
    const { storeConf } = getState().root;

    const [promo, secureInfo, legalNotice] = await lastValueFrom(espotService.getEspotDataByLocations(storeConf.storeId, espots));
    const emptyItemEspots = await lastValueFrom(
      espotService.getEspotByTypeAndStoreId('ESPOT_EMPTY_ITEM', storeConf.storeId)
    ) satisfies EmptyItemEspotType[];

    dispatch(setLayoutEspots({ espots: { promo, secureInfo, legalNotice } }));
    dispatch(setEmptyItemEspots({ emptyItemEspots }));
  }
};
